export default __webpack_public_path__ + "static/media/template11.a29256a7.svg";